/* eslint-disable import/extensions */
import { Context } from './interfaces/context';
import {
  EnvItemHost,
  ItemHostConfig,
  HostConfig,
  ENV_NAME,
} from './interfaces/environment';

import {
  Request,
  MethodType,
  BasicResponse,
  MockStructure,
} from './interfaces/request';

import {
  Sonda,
  WSEventType,
  WSElementType,
  JS_ERROR,
  SondaType,
  SondaInfo,
} from './interfaces/sonda';

import {
  UnknownFunction,
  UnknownObject,
  UnknownFunctionWithUnknownReturn,
  UnknownType,
  UnknownArray,
} from './interfaces/unknown';

/* EXPORTING VARS */
export {
  MethodType,
  WSEventType,
  WSElementType,
  JS_ERROR,
  SondaType,
  ENV_NAME,
};
/* EXPORTING TYPES */
export type {
  Context,
  Request,
  BasicResponse,
  Sonda,
  SondaInfo,
  MockStructure,
  EnvItemHost,
  ItemHostConfig,
  HostConfig,
  UnknownFunction,
  UnknownObject,
  UnknownFunctionWithUnknownReturn,
  UnknownType,
  UnknownArray,
};
